































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import CheckboxSquare from '@/components/atoms/CheckboxSquare.vue'
import RadioToggle from '@/components/atoms/RadioToggle.vue'
import SelectBase from '@/components/atoms/SelectBase.vue'
import { ENGLISH_PUBLISHER_OPTIONS, LITERATURE_PUBLISHER_OPTIONS } from '@/constants'
import { AlignedCourses } from '@/store/modules/StudentCreationInfo'
import { SUBJECTS } from './SelectCoursesStandardTable.vue'
import { CourseResponse } from './v3/ModalStudentCourses.vue'

export const PUBLISHER_SUBJECTS = ['ei', 'ko']

export const PUBLISHER_OPTIONS = {
  ei: ENGLISH_PUBLISHER_OPTIONS,
  ko: LITERATURE_PUBLISHER_OPTIONS,
}

@Component({
  components: {
    ButtonBase,
    CheckboxSquare,
    RadioToggle,
    SelectBase,
  },
})
export default class SelectCoursesAlignedTable extends Vue {
  @Prop()
  private grades!: { text: string; value: string }[]

  @Prop()
  courseDefault?: CourseResponse

  @Watch('alignedCoursesSelected', { deep: true })
  private onCourseSelectedChange(): void {
    this.$emit('onCourseAlignedChange', this.alignedCoursesSelected)
  }

  @Watch('courseDefault', { deep: true })
  private onHandleDefaultStandardData(): void {
    this.handleDefaultAlignedData(true)
  }

  private bordered = true

  private subjects = SUBJECTS

  private publisherOptions = PUBLISHER_OPTIONS
  private hasPublisherSubjects = PUBLISHER_SUBJECTS

  private alignedCoursesSelected: AlignedCourses | null = null

  private handleDefaultAlignedData(isCourseDefaultChange?: boolean) {
    const { courseDefault, hasPublisherSubjects, publisherOptions, grades, subjects } = this

    this.alignedCoursesSelected = grades.reduce((acc: any, grade) => {
      const gradeValue = grade.value

      Object.entries(subjects).forEach(([code, { id: subjectId }]) => {
        if (!acc[gradeValue]) {
          acc[gradeValue] = {}
        }
        const enableAlignedCourse = courseDefault?.courseData.find(
          (course) => course.gradeId === Number(gradeValue) && course.subjectId === Number(subjectId)
        )
        const defaultPublisher = hasPublisherSubjects.includes(code as 'ei' | 'ko')
          ? publisherOptions[code as 'ei' | 'ko'][0].value
          : ''
        const publisher = enableAlignedCourse ? enableAlignedCourse.publisherCode : defaultPublisher

        acc[gradeValue][subjectId] = {
          checked: Boolean(enableAlignedCourse),
          publisher,
        }
      })
      return acc
    }, {})

    if (isCourseDefaultChange) {
      this.$emit('onCourseAlignedChange', this.alignedCoursesSelected)
    }
  }

  private mounted() {
    const { alignedCourses } = this.$store.state.studentCreationInfo.studentInfo
    if (alignedCourses) {
      this.alignedCoursesSelected = alignedCourses
    } else {
      this.handleDefaultAlignedData()
    }
  }

  private tableFields: object[] = [
    { key: 'grade', label: '学年' },
    { key: 'subject', label: '教科' },
    { key: 'publisher', label: '教科書会社' },
  ]
}
